import { render, staticRenderFns } from "./DeliveryDetailsCard.vue?vue&type=template&id=0c0b7700&scoped=true"
import script from "./DeliveryDetailsCard.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetailsCard.vue?vue&type=style&index=0&id=0c0b7700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b7700",
  null
  
)

export default component.exports